import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, ModalGeneric } from 'ypf-pas-general-ui-components';

import './QuantityEntryModal.scss';
import { formatDateToSpanish } from '../../../utils/formatUtils';
import { sendToApproveLines } from '../../../services/workReport';
import useToast from '../../../hooks/useToast';

const QuantityEntryModal = ({
  show,
  onHide,
  onAccept,
  workReportId,
  dailyWorkReportId,
  positionName,
  lineName,
  currentQuantity,
  date
}) => {
  const [quantity, setQuantity] = useState(currentQuantity);
  const [disableButton, setDisableButton] = useState(false);
  const { day, month } = formatDateToSpanish(date);
  const { setNewToast } = useToast();

  useEffect(() => {
    setQuantity(currentQuantity);
  }, [currentQuantity]);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={onHide}
      primaryAction={async () => {
        setDisableButton(true);
        try {
          const response = await sendToApproveLines(workReportId, [
            {
              id: dailyWorkReportId,
              cantidad: quantity
            }
          ]);

          onHide();
          setNewToast({
            type: 'SUCCESS',
            message: response.mensaje
          });
          onAccept();
        } catch (err) {
          setNewToast({
            type: 'ERROR',
            message: err.message
          });
        }
        setDisableButton(false);
      }}
      primaryActionDisabled={disableButton || !quantity}
      primaryActionLabel="Enviar"
      secondaryAction={onHide}
      secondaryActionLabel="Salir"
      show={show}
      size="lg"
      title="Cargar y enviar"
    >
      <>
        <div className="d-flex justify-content-center daily-work-report-info">
          <span>&quot;{positionName}</span>
          <span>{lineName}&quot;</span>
        </div>
        <hr className="my-4" />
        <Input
          className="quantity-input"
          label={`${day?.text} ${day?.number} de ${month}`.toUpperCase()}
          name="quantity"
          onChange={(e) => setQuantity(e.target.value)}
          type="number"
          value={quantity}
        />
      </>
    </ModalGeneric>
  );
};

export default QuantityEntryModal;

QuantityEntryModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAccept: PropTypes.func,
  workReportId: PropTypes.number,
  dailyWorkReportId: PropTypes.number,
  positionName: PropTypes.string,
  lineName: PropTypes.string,
  currentQuantity: PropTypes.number,
  date: PropTypes.string
};

QuantityEntryModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  },
  workReportId: null,
  dailyWorkReportId: null,
  positionName: '',
  lineName: '',
  currentQuantity: 0,
  date: ''
};
